/**
 * Arabic for what the API says about a field (apperr.Field, and the schema validator's
 * "expected …"). The API speaks English; forms speak the user's language. The frontend
 * architecture test fails when the backend gains a message that isn't here.
 */
export const fieldMessagesAr: Record<string, string> = {
  "1 or 12": "1 أو 12.",
  "1, 3 or 5": "1 أو 3 أو 5.",
  "25, 465, 587 or 2525": "25 أو 465 أو 587 أو 2525.",
  "ETA is for companies in Egypt": "منظومة الفاتورة الإلكترونية المصرية للشركات في مصر فقط.",
  "ClientOS doesn't open workspaces in this country yet": "لا يفتح ClientOS مساحات عمل في هذه الدولة بعد.",
  "a PNG image of up to 200 KB": "صورة PNG لا يزيد حجمها عن 200 كيلوبايت.",
  "an address like 1.2.3.4 or a range like 1.2.3.0/24": "عنوان مثل 1.2.3.4 أو نطاق مثل 1.2.3.0/24.",
  "a PNG image of up to 2000×1000 pixels": "صورة PNG لا تزيد أبعادها عن 2000×1000 بكسل.",
  "a cash or bank account no other one uses": "اختر حساب نقدية أو بنك غير مربوط بخزينة أو حساب بنكي آخر.",
  "a task, a call or a meeting": "مهمة أو اتصال أو اجتماع.",
  "a custom period needs its first and last day": "الفترة التي تختارها تحتاج يومها الأول والأخير.",
  "a category can't be under itself": "لا يمكن أن يكون التصنيف تحت نفسه أو تحت تصنيف من داخله.",
  "a debit or a credit": "مدين أو دائن، لا الاثنان معاً.",
  "a debit note sent no goods to take back": "إشعار المدين لا يخرج منه أي بضاعة، فلا يوجد ما يُرجَع للمخزن.",
  "a trip is at most 90 days":"المأمورية 90 يوماً على الأكثر.",
  "a credit limit can't be negative": "حد الائتمان لا يمكن أن يكون سالباً.",
  "a channel's kind can't change": "لا يمكن تغيير نوع القناة بعد إنشائها.",
  "a department can't be under itself": "لا يمكن أن يتبع القسم نفسه.",
  "a line without a product needs its price": "السطر بدون صنف يحتاج سعراً.",
  "a page's pattern, such as /invoicing/invoices/$id": "نمط صفحة، مثل ‎/invoicing/invoices/$id.",
  "a product can't be made of itself": "لا يمكن أن يدخل المنتج في تصنيع نفسه.",
  "a product or a description": "اختر صنفاً أو اكتب وصفاً.",
  "a mail server on the internet": "خادم بريد متاح على الإنترنت، لا على شبكة داخلية.",
  "a public address": "عنوان متاح على الإنترنت.",
  "a reason is required": "اكتب السبب.",
  "a reason is required for deductions": "اكتب سبب الخصم.",
  "a sale contract makes a unit sold": "تصبح الوحدة «مباعة» بعقد بيع فقط.",
  "a sold unit stays in its project": "الوحدة المباعة تبقى في مشروعها.",
  "a task can't be its own parent": "لا يمكن أن تكون المهمة فرعية من نفسها.",
  "a task can't move to another project": "لا يمكن نقل المهمة إلى مشروع آخر.",
  "a discount is between 0 and 100": "الخصم بين 0 و100.",
  "a domain of your own, not a ClientOS address": "نطاق تملكه أنت، لا عنواناً على ClientOS.",
  "a domain such as app.yourcompany.com": "نطاق مثل app.yourcompany.com.",
  "a link starting with https://": "رابط يبدأ بـ https://.",
  "a workspace can't be both let in and kept out": "لا تضع مساحة العمل في القائمتين معاً: مفعّل دائماً ومغلق دائماً.",
  "access token and app secret are required": "رمز الوصول والمفتاح السري للتطبيق مطلوبان.",
  "account not found": "الحساب غير موجود.",
  "add the currency to the company first": "أضف العملة إلى عملات الشركة أولاً.",
  "already holds a custody": "لديه عهدة نقدية بالفعل في هذه الشركة.",
  "amounts can't be negative": "المبالغ لا يمكن أن تكون سالبة.",
  "an account can't be its own parent": "لا يمكن أن يتبع الحساب نفسه.",
  "an account other than cash, banks, customers and suppliers": "اختر حساباً غير الخزائن والبنوك والعملاء والموردين: لكل منها شاشته.",
  "an account with money through it keeps its kind and currency": "الحساب الذي مرت عليه مبالغ لا يتغير نوعه ولا عملته.",
  "another partner has this code": "لشريك آخر هذا الكود؛ اختر كوداً غيره.",
  "another workspace has this address": "لمساحة عمل أخرى هذا العنوان، أو كان لها مؤخراً.",
  "an active asset account": "اختر حساب أصول نشطاً.",
  "an active expense account": "اختر حساب مصروفات نشطاً.",
  "an active income account": "اختر حساب إيرادات نشطاً.",
  "an active liability account": "اختر حساب خصوم نشطاً.",
  "an active user can't go back to invited": "المستخدم النشط لا يعود إلى حالة «مدعو».",
  "an email address": "اكتب بريداً إلكترونياً صحيحاً.",
  "an email for the receipt is required": "اكتب البريد الإلكتروني لإرسال الإيصال.",
  "an employee can't manage themself": "لا يمكن أن يكون الموظف مديراً لنفسه.",
  "already buys at another price list": "العميل على قائمة أسعار أخرى؛ احذفه منها أولاً.",
  "an https:// address": "عنوان يبدأ بـ https://",
  "an income or expense account, once": "حساب إيرادات أو مصروفات، مرة واحدة فقط.",
  "another product has this barcode": "الباركود مستخدم لصنف آخر أو هو رمز صنف آخر.",
  "another price list has this name": "توجد قائمة أسعار بهذا الاسم.",
  "another product has this SKU": "الرمز مستخدم لصنف آخر.",
  "at most 100 variants": "100 صنف على الأكثر (عدد القيم مضروباً في بعضه).",
  "at most 200 characters each": "200 حرف على الأكثر لكل واحد.",
  "add the secret key too": "أضف المفتاح السري أيضاً.",
  "not one of this company's statuses": "اختر حالة من حالات الشركة.",
  "two statuses with one name": "لكل حالة اسم مختلف.",
  "every kind keeps a status": "أبقِ حالة واحدة على الأقل من كل نوع.",
  "a quote of this deal": "اختر عرض سعر من عروض هذه الصفقة.",
  "a lost stage can't need anything": "مرحلة الخسارة لا تُشترط لها أي شروط.",
  "one of the lead sources": "اختر مصدراً من مصادر العملاء المحتملين.",
  "the tag it scores": "اكتب الوسم الذي تُحسب له النقاط.",
  "scores a lead that has one: no value": "هذه القاعدة لا تحتاج قيمة.",
  "started on records already: make a new sequence": "بدأت السلسلة على سجلات من قبل؛ أنشئ سلسلة جديدة.",
  "an email, a WhatsApp message or a task": "بريد أو رسالة واتساب أو متابعة.",
  "not what this sequence is for": "هذه السلسلة لنوع آخر من السجلات.",
  "a salesperson's or a team's": "حدّد مندوباً أو فريقاً.",
  "not one of this company's people or teams": "اختر مندوباً أو فريقاً من هذه الشركة.",
  "the first day of the month, or of the quarter": "أول يوم في الشهر أو في الربع.",
  "not one of the country's regions": "اختر محافظة أو منطقة من القائمة.",
  "does not belong to this search": "هذه الصفحة لبحث آخر: ابدأ البحث من جديد.",
  "one of them is not in the pool": "أحد الأنشطة المختارة لم يعد موجوداً: حدّث البحث وأعد المحاولة.",
  "a governorate in another territory already": "إحدى المحافظات في منطقة أخرى بالفعل.",
  "after the contract starts": "تنتهي العقود بعد بدايتها.",
  "must be a month (YYYY-MM)": "اكتب شهراً صحيحاً.",
  "the owner keeps what the team doesn't take": "المسؤول لا يُضاف للفريق: له ما يتبقى.",
  "each teammate once, with a share above 0": "كل زميل مرة واحدة، بنصيب أكبر من صفر.",
  "the shares leave the owner some": "يجب أن يبقى للمسؤول نصيب.",
  "a saved report or an app's": "اختر تقريراً محفوظاً أو تقريراً من التطبيقات.",
  "not a report you may send here": "لا يمكنك إرسال هذا التقرير هنا.",
  "a JPEG, PNG or WebP photo": "صورة بصيغة JPEG أو PNG أو WebP.",
  "not a browser's push service": "عنوان التنبيهات ليس من خدمات المتصفحات.",
  "this stage needs a contact person": "هذه المرحلة تحتاج جهة اتصال للصفقة.",
  "this stage needs an amount": "هذه المرحلة تحتاج قيمة للصفقة.",
  "this stage needs an expected close date": "هذه المرحلة تحتاج تاريخ الإغلاق المتوقع.",
  "this stage needs the deal's products": "هذه المرحلة تحتاج منتجات الصفقة.",
  "this stage needs a quote sent to the customer": "هذه المرحلة تحتاج عرض سعر مُرسلاً للعميل.",
  "993 or 143": "993 أو 143.",
  "this record can't be handed to someone": "لا يُسند هذا السجل إلى أحد.",
  "this record has no customer to write to": "لا عميل في هذا السجل يُراسَل.",
  "mail comes from the server encrypted": "يصل البريد من الخادم مشفّراً: اختر SSL/TLS أو STARTTLS.",
  "the mailbox didn't open with this sign-in": "لم يُفتح الصندوق بهذا الدخول: راجع كلمة المرور أو كلمة مرور التطبيقات والخادم.",
  "at most 24 months after from": "24 شهراً على الأكثر بعد البداية.",
  "at most 31 days after from": "31 يوماً على الأكثر بعد البداية.",
  "at most 500 units at once": "500 وحدة كحد أقصى في المرة الواحدة.",
  "at most 600 characters, to show in the app": "600 حرف على الأكثر، لتظهر في التطبيق.",
  "at most a year after from": "سنة واحدة على الأكثر بعد البداية.",
  "at most the cost less the salvage value": "لا يزيد عن التكلفة ناقص قيمة الخردة.",
  "at most three months per query": "ثلاثة أشهر كحد أقصى في المرة الواحدة.",
  "attach the file to this conversation first": "أرفق الملف بالمحادثة أولاً.",
  "batch not found": "التشغيلة غير موجودة.",
  "between 1 and 10 steps": "من خطوة إلى عشر خطوات.",
  "between 0 and 100": "من 0 إلى 100.",
  "between 1 and 60": "من 1 إلى 60.",
  "between a quarter day and five days": "من ربع يوم إلى خمسة أيام.",
  "bill not found": "فاتورة المورد غير موجودة.",
  "branch belongs to another company": "الفرع يتبع شركة أخرى.",
  "branch not found": "الفرع غير موجود.",
  "built-in types keep their form": "الأنواع الأساسية تحتفظ بنموذجها: ما ينفّذه التطبيق بعد الموافقة يقرأ حقوله.",
  "built-in types keep their key": "الأنواع المدمجة تحتفظ بمفتاحها.",
  "can't be in the future": "لا يمكن أن يكون في المستقبل.",
  "another employee has this number": "لموظف آخر هذا الرقم في جهاز البصمة.",
  "two employees can't have the same number": "لا يكون لموظفين اثنين نفس رقم البصمة.",
  "must be a time like 2026-10-05T17:00": "اختر اليوم والوقت.",
  "is before they were hired": "قبل تاريخ تعيين الموظف.",
  "can't be in the past": "لا يمكن أن يكون في الماضي.",
  "another column already fills this field": "عمود آخر يملأ هذا الحقل.",
  "can't be negative": "لا يمكن أن تكون القيمة سالبة.",
  "can't be negative; use a deduction component": "لا يمكن أن تكون سالبة؛ استخدم بند خصم.",
  "can't log time in the future": "لا يمكن تسجيل وقت في المستقبل.",
  "cash goes to a cash box": "النقدية تدخل خزينة، لا حساباً بنكياً.",
  "category not found": "التصنيف غير موجود.",
  "choose a bank account or wallet": "اختر حساباً بنكياً أو محفظة.",
  "choose a bank or cash account": "اختر حساب بنك أو صندوق.",
  "choose a different warehouse": "اختر مخزناً مختلفاً.",
  "choose a role": "اختر دوراً.",
  "choose a user": "اختر مستخدماً.",
  "compare numbers and dates only": "المقارنة بالأكبر والأصغر للأرقام والتواريخ فقط.",
  "day, week, month, quarter or year": "يوم أو أسبوع أو شهر أو ربع سنة أو سنة.",
  "contains is for text": "«يحتوي على» للنصوص فقط.",
  "choose an active cash box": "اختر خزينة نشطة.",
  "choose an organization marked as supplier": "اختر جهة مسجلة كمورد.",
  "choose organizations marked as supplier": "اختر جهات مسجلة كموردين.",
  "a supplier is listed twice": "مورد مذكور مرتين.",
  "a supplier that declined has no prices": "المورد المعتذر ليس له أسعار.",
  "a line can only go to a supplier that quoted it": "لا يُرسى البند إلا على مورد سعّره.",
  "each award is for one of the request's lines": "كل ترسية تخص أحد بنود الطلب.",
  "each line needs a product or a description": "كل بند يحتاج منتجاً أو وصفاً.",
  "each price is for one of the request's lines, once": "كل سعر لبند من بنود الطلب، مرة واحدة.",
  "enter at least one price, or mark the supplier as declined": "أدخل سعراً واحداً على الأقل، أو علّم المورد معتذراً.",
  "must not be before the day the suppliers should answer": "لا يسبق يوم رد الموردين.",
  "required for a foreign currency": "مطلوب للعملة الأجنبية.",
  "choose another account": "اختر حساباً آخر.",
  "choose the account it waits in": "اختر الحساب الذي ينتظر فيه المبلغ.",
  "choose the account it's for": "اختر الحساب الذي يقابله المبلغ.",
  "choose the counter account": "اختر الحساب المقابل.",
  "choose the supplier: Form 41 lists whom the tax was withheld from": "اختر المورد: نموذج 41 يذكر من خُصمت منه الضريبة.",
  "choose the tax the amount includes": "اختر الضريبة المضمّنة في المبلغ.",
  "choose the warehouse the goods leave from": "اختر المخزن الذي تخرج منه البضاعة.",
  "contact belongs to another organization": "جهة الاتصال تتبع عميلاً آخر.",
  "contact doesn't belong to this customer": "جهة الاتصال لا تتبع هذا العميل.",
  "contact not found": "جهة الاتصال غير موجودة.",
  "cost center not found": "مركز التكلفة غير موجود.",
  "country can't change after creation": "لا يمكن تغيير الدولة بعد الإنشاء.",
  "currencies are 3-letter codes such as USD": "العملة رمز من 3 حروف مثل USD.",
  "currencies must differ": "اختر عملتين مختلفتين.",
  "custom fields aren't supported on this entity": "الحقول المخصصة غير متاحة لهذا النوع.",
  "customer not found": "العميل غير موجود.",
  "a myshopify.com address": "اكتب عنوان المتجر على شوبيفاي، مثل mystore.myshopify.com.",
  "mail goes to the server encrypted": "يصل البريد إلى الخادم مشفّراً.",
  "make another account the default instead": "اجعل حساباً آخر هو الافتراضي بدلاً منه.",
  "needs the inventory app": "يحتاج تطبيق المخزون.",
  "days are 0 (Sunday) to 6 (Saturday)": "الأيام من 0 (الأحد) إلى 6 (السبت).",
  "days are 0 (Sunday) to 6 with open before close": "الأيام من 0 (الأحد) إلى 6، ووقت البداية قبل النهاية.",
  "days are keyed 0 (Sunday) to 6 (Saturday)": "الأيام من 0 (الأحد) إلى 6 (السبت).",
  "deal belongs to another organization": "الصفقة تتبع عميلاً آخر.",
  "documents carry this unit: add another unit for the new size": "الوحدة مستخدمة في مستندات بعددها الحالي؛ للحجم الجديد أضف وحدة أخرى (كرتونة كبيرة مثلاً).",
  "deal not found": "الصفقة غير موجودة.",
  "duplicate invoice": "الفاتورة مكررة.",
  "duplicate key": "المفتاح مكرر.",
  "each class has its own code": "لكل فئة رمز مختلف.",
  "each criterion needs its own key": "كل معيار يحتاج مفتاحاً مختلفاً.",
  "each day needs a valid start and end (HH:MM)": "كل يوم يحتاج وقت بداية ونهاية صحيحين (ساعة:دقيقة).",
  "each span runs from an earlier time to a later one": "كل فترة تبدأ قبل أن تنتهي.",
  "employee not found": "الموظف غير موجود.",
  "empty for an asset depreciated before": "اتركه فارغاً للأصل الذي أُهلك من قبل.",
  "empty serial number": "الرقم التسلسلي فارغ.",
  "enter an email address": "أدخل بريداً إلكترونياً صحيحاً.",
  "entity, key, and type can't change; create a new field instead": "لا يمكن تغيير نوع الحقل أو مفتاحه؛ أنشئ حقلاً جديداً.",
  "entity_type and entity_id are required unless mine=true": "حدد السجل المطلوب.",
  "exceeds the bill's balance": "أكبر من المتبقي على الفاتورة.",
  "exempt and zero-rated codes have a 0 rate": "الضريبة المعفاة أو الصفرية نسبتها 0.",
  "expiry needs batch tracking": "تاريخ الصلاحية يحتاج التتبع بالتشغيلة.",
  "group and inactive accounts can't receive postings": "لا يمكن الترحيل على حساب رئيسي أو موقوف.",
  "incorrect password": "كلمة المرور غير صحيحة.",
  "invalid cursor": "رابط الصفحة غير صالح؛ أعد التحميل.",
  "invalid reference": "المرجع غير صالح.",
  "invalid timestamp": "الوقت غير صالح.",
  "invited users become active by accepting the invitation": "المستخدم المدعو يصبح نشطاً عند قبول الدعوة.",
  "invoice belongs to another customer": "الفاتورة تخص عميلاً آخر.",
  "invoice currency differs from the payment currency": "عملة الفاتورة تختلف عن عملة الدفعة.",
  "invoice not found": "الفاتورة غير موجودة.",
  "item not found": "العنصر غير موجود.",
  "item not in this contract": "البند ليس ضمن هذا العقد.",
  "leave type not available": "نوع الإجازة غير متاح.",
  "leave type not found": "نوع الإجازة غير موجود.",
  "less than the cost": "أقل من التكلفة.",
  "listed twice": "مكرر.",
  "line not on this invoice": "السطر ليس في هذه الفاتورة.",
  "lines must be unreconciled postings on the statement's account": "اختر حركات غير مسوّاة على حساب الكشف نفسه.",
  "me, none, or a user id": "أنا، أو لا أحد، أو مستخدم محدد.",
  "min must be ≥ 0 and reorder quantity > 0": "الحد الأدنى صفر أو أكثر، وكمية إعادة الطلب أكبر من صفر.",
  "months 1–12, from before to": "الأشهر من 1 إلى 12، والبداية قبل النهاية.",
  "must be at least the first floor": "الدور الأخير لا يكون قبل الدور الأول.",
  "must be a date (YYYY-MM-DD)": "اكتب تاريخاً صحيحاً.",
  "must be a number": "اكتب رقماً.",
  "must be a posted bill of this supplier in the payment currency": "اختر فاتورة مرحّلة لهذا المورد بعملة الدفعة.",
  "must be a posting account of this company": "اختر حساباً فرعياً في هذه الشركة.",
  "must be a time (HH:MM)": "اكتب وقتاً صحيحاً (ساعة:دقيقة).",
  "must be after from": "لا بد أن يكون بعد البداية.",
  "must be after the next run date": "لا بد أن يكون بعد موعد التشغيل التالي.",
  "must be after the start": "لا بد أن يكون بعد البداية.",
  "must be after the start date": "لا بد أن يكون بعد تاريخ البداية.",
  "must be a date": "لا بد أن يكون تاريخًا.",
  "must be an active variable component": "اختر بنداً متغيراً نشطاً.",
  "must be between 0 and 100": "من 0 إلى 100.",
  "must be between 0 and the invoiced quantity": "من صفر حتى الكمية المفوترة.",
  "must be between 0 and the price": "من صفر حتى السعر.",
  "must be between 0 and the price after discount": "من صفر حتى السعر بعد الخصم.",
  "must be greater than 0": "لا بد أن تكون أكبر من صفر.",
  "must be less than the amount": "لا بد أن تكون أقل من المبلغ.",
  "must be less than the amount before tax": "لا بد أن تكون أقل من المبلغ قبل الضريبة.",
  "must be more than zero": "لا بد أن تكون أكبر من صفر.",
  "must be on or after the issue date": "لا يسبق تاريخ الإصدار.",
  "must be on or after the start": "لا يسبق البداية.",
  "must be on or after the start date": "لا يسبق تاريخ البداية.",
  "must be positive": "لا بد أن تكون أكبر من صفر.",
  "not one of this import's fields": "ليس من حقول هذا الاستيراد.",
  "must be text": "اكتب نصاً.",
  "must be true or false": "نعم أو لا.",
  "not a date": "اكتب تاريخاً صحيحاً.",
  "not a line of this bill": "السطر ليس في فاتورة المورد هذه.",
  "not a line of this order": "السطر ليس في أمر الشراء هذا.",
  "not a line of this order for this product": "السطر ليس في أمر الشراء لهذا الصنف.",
  "not a parameter of this rule pack": "ليس من إعدادات هذه الحزمة.",
  "not a value of this attribute": "ليست من قيم هذه الخاصية.",
  "not a variant of this group": "ليس من أصناف هذه المجموعة.",
  "not for this kind of voucher here": "هذا البند لا يصلح لهذا النوع من السندات.",
  "not one of the employee's family": "ليس من أفراد أسرة الموظف.",
  "not one of the policy's classes": "ليست من فئات الوثيقة.",
  "not a posted goods receipt": "ليس استلاماً مرحّلاً.",
  "not an X.509 certificate": "الملف ليس شهادة رقمية صالحة.",
  "not an approved template; sync templates first": "القالب غير معتمد؛ حدّث القوالب أولاً.",
  "not an id": "اختر من القائمة.",
  "not a cursor from this list": "انتهت صلاحية هذه الصفحة من القائمة؛ أعد فتحها.",
  "pick its tax code": "اختر ضريبة هذا البند: معفى أو صفري إن لم تكن عليه ضريبة.",
  "not base64": "الملف غير صالح.",
  "not found": "غير موجود.",
  "not one of the options": "اختر من الخيارات المتاحة.",
  "not a field of this trigger": "ليس من حقول هذا الحدث.",
  "not one of this report's fields": "ليس من حقول هذه البيانات.",
  "not one of this report's figures": "ليس من أرقام هذه البيانات.",
  "not something reports can be built on here": "ليست بيانات تُبنى عليها التقارير في هذه المساحة.",
  "not something automations can start from here": "ليس حدثاً تبدأ منه الأتمتة في هذه المساحة.",
  "on or after from": "في تاريخ البداية أو بعده.",
  "on or after the next date": "في تاريخ القيد التالي أو بعده.",
  "on or after the payment date": "لا يسبق تاريخ الدفعة.",
  "once only": "كل وحدة مرة واحدة فقط.",
  "one serial number per unit returned": "رقم تسلسلي واحد لكل وحدة مرتجعة.",
  "only a sold unit is delivered": "تُسلَّم الوحدة المباعة فقط.",
  "only for payments by cheque": "للدفع بالشيكات فقط.",
  "only those who post invoices can set a credit limit": "حد الائتمان يضعه من يرحّل الفواتير (المحاسب أو المدير المالي).",
  "only the last branch can be unconditional": "الفرع الأخير فقط يمكن أن يكون بدون شرط.",
  "organization not found": "الجهة غير موجودة.",
  "parent not found": "العنصر الرئيسي غير موجود.",
  "parent task not in this project": "المهمة الرئيسية ليست في هذا المشروع.",
  "personal tasks can only be assigned to yourself": "المهام الشخصية تُسند إليك فقط.",
  "pick a darker color: white writing on it must be easy to read": "اختر لوناً أغمق: يجب أن تُقرأ الكتابة البيضاء عليه بسهولة.",
  "pick a plan from the price list": "اختر خطة من قائمة الأسعار.",
  "the client's own email, not yours": "بريد مالك الشركة نفسه، لا بريدك.",
  "pick apps from the list": "اختر التطبيقات من القائمة.",
  "pick from the welcome step's answers": "اختر من إجابات خطوة الترحيب.",
  "pick plans from the list": "اختر الخطط من القائمة.",
  "pick how it was paid": "اختر طريقة الدفع.",
  "use only the fields this email fills in": "استخدم فقط الحقول التي يملؤها هذا الإيميل.",
  "pick today or a later date": "اختر اليوم أو تاريخاً لاحقاً.",
  "pick workspaces from the list": "اختر مساحات العمل من القائمة.",
  "premiums can't be negative": "الأقساط لا يمكن أن تكون سالبة.",
  "prices can't be negative": "الأسعار لا يمكن أن تكون سالبة.",
  "product not found": "الصنف غير موجود.",
  "can't be before the order date": "لا يكون قبل تاريخ الأمر.",
  "not a line of this sales order": "ليس بنداً في أمر البيع هذا.",
  "isn't the product and unit of its sales order line": "ليس صنف بند أمر البيع ووحدته.",
  "product or barcode required": "اختر صنفاً أو امسح الباركود.",
  "project not found": "المشروع غير موجود.",
  "provider doesn't match the company's country": "مزوّد الخدمة لا يعمل في دولة الشركة.",
  "provider not found": "مقدم الخدمة غير موجود.",
  "quantities must be more than zero": "الكميات لا بد أن تكون أكبر من صفر.",
  "quantities must be positive": "الكميات لا بد أن تكون أكبر من صفر.",
  "quantity and rate can't be negative": "الكمية والسعر لا يمكن أن يكونا سالبين.",
  "quantity must be positive and price non-negative": "الكمية أكبر من صفر والسعر صفر أو أكثر.",
  "rate each criterion from 1 to 5": "قيّم كل معيار من 1 إلى 5.",
  "rate must be between 0 and 100": "النسبة من 0 إلى 100.",
  "rate must be positive": "النسبة لا بد أن تكون أكبر من صفر.",
  "rate the cycle's criteria only": "قيّم معايير الدورة فقط.",
  "recompute at most two months at a time": "أعد الحساب لشهرين كحد أقصى في المرة الواحدة.",
  "referenced record not found": "السجل المختار غير موجود.",
  "request type not found": "نوع الطلب غير موجود.",
  "required": "مطلوب.",
  "required for foreign-currency bills": "مطلوب لفواتير الموردين بعملة أجنبية.",
  "required for foreign-currency orders": "مطلوب لأوامر الشراء بعملة أجنبية.",
  "required for foreign-currency payments": "مطلوب للدفعات بعملة أجنبية.",
  "required for formula components": "مطلوب للبنود المحسوبة بمعادلة.",
  "required when disqualifying": "مطلوب عند الاستبعاد.",
  "required when receiving against an order": "مطلوب عند الاستلام على أمر شراء.",
  "required when rejecting": "مطلوب عند الرفض.",
  "required with a withholding rate": "مطلوب مع نسبة الخصم والإضافة.",
  "required without a product": "مطلوب إن لم تختر صنفاً.",
  "required without an order": "مطلوب بدون أمر شراء.",
  "role not found": "الدور غير موجود.",
  "rule and system components are built in": "بنود النظام والقواعد مدمجة ولا تُعدّل.",
  "say how the employment ended": "اختر سبب انتهاء الخدمة.",
  "say why the workspace is being suspended or cancelled": "اكتب سبب إيقاف مساحة العمل أو إلغائها.",
  "say why: it goes in the audit log": "اكتب السبب: يُحفظ في سجل العمليات.",
  "the end comes after the start": "النهاية بعد البداية.",
  "type the workspace's address to confirm": "اكتب عنوان المساحة للتأكيد.",
  "type the workspace's address as it shows": "اكتب عنوان مساحة العمل كما يظهر.",
  "a phone number of at least 8 digits": "اكتب رقم هاتف من 8 أرقام على الأقل.",
  "their email or phone": "اكتب بريده أو رقم هاتفه.",
  "this subdomain is taken": "هذا العنوان مستخدم لمساحة أخرى.",
  "this record has no owner to tell": "لا صاحب لهذا السجل يُبلَّغ؛ اختر دوراً أو شخصاً.",
  "this record already has a field with that key": "في هذه السجلات حقل بهذا المفتاح بالفعل.",
  "a workspace from a template needs its owner's name and email": "المساحة من قالب تحتاج اسم مالكها وبريده.",
  "this code isn't valid": "هذا الكود غير صالح.",
  "this code has been used up": "استُخدم هذا الكود بالكامل.",
  "this workspace has used this code": "استخدمت مساحة العمل هذا الكود من قبل.",
  "select fields need options": "حقل الاختيار يحتاج خيارات.",
  "service not found": "الخدمة غير موجودة.",
  "set the WhatsApp Business Account id first": "أدخل معرّف حساب واتساب للأعمال أولاً.",
  "stage not found": "المرحلة غير موجودة.",
  "stage not in this pipeline": "المرحلة ليست في مسار البيع هذا.",
  "status not in this project": "الحالة ليست في هذا المشروع.",
  "subtasks are one level deep": "المهام الفرعية مستوى واحد فقط.",
  "supplier not found": "المورد غير موجود.",
  "system components keep their code, kind, and calculation": "بنود النظام تحتفظ برمزها ونوعها وطريقة حسابها.",
  "system types are built in": "أنواع النظام مدمجة ولا تُعدّل.",
  "task not in this project": "المهمة ليست في هذا المشروع.",
  "tax code not found": "الضريبة غير موجودة.",
  "tax code not found in this company": "الضريبة غير موجودة في هذه الشركة.",
  "team not found": "الفريق غير موجود.",
  "templates are for WhatsApp": "القوالب لقنوات واتساب فقط.",
  "the account is switched off": "هذا الحساب موقوف.",
  "the mailbox's password or app password": "اكتب كلمة مرور البريد أو كلمة مرور التطبيقات.",
  "the attributes are set when the group is made": "الخصائص تُحدَّد عند إنشاء الصنف؛ يمكن تعديل أسمائها وقيمها فقط.",
  "the account is in another currency": "الحساب بعملة أخرى.",
  "the authentication code is invalid": "رمز التحقق غير صحيح.",
  "the component is listed twice": "الخامة مكررة.",
  "the default account stays on": "الحساب الافتراضي لا يُوقف.",
  "the employee has no contract to change the salary of": "ليس للموظف عقد يُعدَّل راتبه؛ أضف عقده أولاً.",
  "the component is listed twice, or is what's made": "الخامة مكررة، أو هي نفسها المنتج المصنّع.",
  "the item is twice in the claim": "البند مكرر في المستخلص.",
  "the order belongs to another supplier": "أمر الشراء يخص مورداً آخر.",
  "the product doesn't come in this unit": "الصنف لا يُباع ولا يُشترى بهذه الوحدة. أضفها في وحدات الصنف من صفحته.",
  "the product is listed twice from this quantity": "الصنف مكرر بنفس الكمية والوحدة في القائمة.",
  "the product's own unit": "هذه وحدة الصنف الأساسية؛ أضف وحدة أكبر منها (كرتونة، علبة).",
  "the parent must be a group account of the same type": "الحساب الرئيسي لا بد أن يكون حساباً تجميعياً من النوع نفسه.",
  "the rest of the price needs at least one installment": "باقي الثمن يحتاج قسطاً واحداً على الأقل.",
  "the unit has a sale contract: cancel it first": "للوحدة عقد بيع؛ ألغه أولاً.",
  "the weights make 100": "مجموع الأوزان لا بد أن يكون 100.",
  "times are HH:MM": "اكتب الوقت بصيغة ساعة:دقيقة.",
  "this account requires a cost center": "هذا الحساب يتطلب مركز تكلفة.",
  "this address is already on the partner portal": "هذا البريد مسجّل بالفعل على بوابة الشركاء.",
  "today": "تاريخ اليوم.",
  "this invoice was partially credited; choose the lines to credit": "صدر إشعار دائن لجزء من الفاتورة؛ اختر السطور.",
  "this provider doesn't give this service": "مقدم الخدمة لا يقدم هذه الخدمة.",
  "this request type isn't available to you": "نوع الطلب هذا غير متاح لك.",
  "this subdomain is reserved": "هذا العنوان محجوز؛ اختر عنواناً آخر.",
  "type your name to accept": "اكتب اسمك للموافقة.",
  "unit not found": "الوحدة غير موجودة.",
  "unknown currency": "عملة غير معروفة.",
  "unknown custom field": "حقل مخصص غير معروف.",
  "unknown customer": "عميل غير موجود.",
  "unknown field": "حقل غير معروف.",
  "unknown filter": "تصفية غير معروفة.",
  "each at most 40 characters": "كل وسم 40 حرفاً على الأكثر.",
  "a phone or an email is needed": "اكتب رقم هاتف أو بريداً إلكترونياً.",
  "invalid email": "البريد الإلكتروني غير صحيح.",
  "choose another record": "اختر سجلاً غير هذا.",
  "YYYY-MM": "اكتب الشهر هكذا: 2026-09.",
  "what reached the other account, in its currency": "اكتب المبلغ الذي وصل للحساب الآخر بعملته.",
  "within a year after from": "الفترة سنة على الأكثر، ونهايتها بعد بدايتها.",
  "must add up to 100": "يجب أن يكون مجموع الأوزان 100.",
  "a manual indicator needs its unit and direction": "المؤشر اليدوي يحتاج وحدته واتجاهه.",
  "an indicator appears once": "المؤشر يظهر مرة واحدة في البطاقة.",
  "between 0 and 5": "يجب أن يكون بين 0 و5.",
  "each target above 0": "كل هدف يجب أن يكون أكبر من صفر.",
  "unknown employee": "موظف غير موجود.",
  "unknown indicator": "مؤشر غير موجود.",
  "unknown measure": "مصدر غير معروف.",
  "a sum, or a share of the profit": "حدد مبلغاً أو نسبة من صافي الربح.",
  "above 0": "يجب أن يكون أكبر من صفر.",
  "choose who's in it": "اختر المستحقين.",
  "on or after the start": "يجب ألا يسبق البداية.",
  "ratings 1 to 5, each 0% to 500%": "التقييمات من 1 إلى 5، ولكل منها نسبة من 0% إلى 500%.",
  "set what each rating is worth": "حدد نسبة كل تقييم.",
  "a line needs a quantity above 0, a price of 0 or more and a discount from 0 to 100": "كل بند يحتاج كمية أكبر من صفر، وسعراً صفراً أو أكثر، وخصماً من 0 إلى 100.",
  "unknown plan": "باقة غير معروفة.",
  "unknown time zone": "منطقة زمنية غير معروفة.",
  "unsupported entity": "نوع غير مدعوم.",
  "unsupported sort column": "ترتيب غير مدعوم.",
  "use 3–30 lowercase letters, digits, or single hyphens": "من 3 إلى 30 حرفاً إنجليزياً صغيراً أو رقماً أو شرطة.",
  "use the convert endpoint": "استخدم «تحويل إلى صفقة».",
  "user not found": "المستخدم غير موجود.",
  "user not found or inactive": "المستخدم غير موجود أو موقوف.",
  "values can't be negative": "القيم لا يمكن أن تكون سالبة.",
  "within the policy's dates": "داخل مدة الوثيقة.",
  "warehouse not found or inactive": "المخزن غير موجود أو موقوف.",
  "weekdays are 0 (Sunday) to 6": "أيام الأسبوع من 0 (الأحد) إلى 6.",
  "where the money went": "اختر الحساب الذي ذهب إليه المبلغ.",
  "withholding tax applies to companies in Egypt": "الخصم والإضافة لشركات مصر فقط.",
  // The password policy (secure.ErrWeakPassword).
  "password must be at least 10 characters and include a letter and a digit": "كلمة المرور 10 أحرف على الأقل وفيها حرف ورقم.",
};

/** Messages built with a value in them, and the schema validator's. */
const patternsAr: [RegExp, (m: RegExpMatchArray) => string][] = [
  [/^expected required property \S+ to be present$/, () => "مطلوب."],
  [/^expected length >= 1$/, () => "مطلوب."],
  [/^expected length >= (\d+)$/, (m) => `${m[1]} أحرف على الأقل.`],
  [/^expected length <= (\d+)$/, (m) => `${m[1]} حرفاً كحد أقصى.`],
  [/^expected number >= (\S+)$/, (m) => `لا تقل عن ${m[1]}.`],
  [/^expected number > (\S+)$/, (m) => `أكبر من ${m[1]}.`],
  [/^expected number <= (\S+)$/, (m) => `لا تزيد عن ${m[1]}.`],
  [/^expected number < (\S+)$/, (m) => `أقل من ${m[1]}.`],
  [/^expected (number|integer)/, () => "اكتب رقماً."],
  [/^expected array length >= 1$/, () => "أضف سطراً واحداً على الأقل."],
  [/^expected array length >= (\d+)$/, (m) => `أضف ${m[1]} على الأقل.`],
  [/^expected array length <= (\d+)$/, (m) => `${m[1]} كحد أقصى.`],
  [/^expected value to be one of/, () => "اختر من الخيارات المتاحة."],
  [/^expected string to be RFC 5322 email/, () => "اكتب بريداً إلكترونياً صحيحاً."],
  [/^expected string to be RFC 3339 date-time/, () => "اكتب تاريخاً ووقتاً صحيحين."],
  [/^expected string to be RFC 3339 date/, () => "اكتب تاريخاً صحيحاً."],
  [/^expected string to be RFC 3339 time/, () => "اكتب وقتاً صحيحاً."],
  [/^expected string to be RFC 4122 uuid/, () => "اختر من القائمة."],
  [/^expected string to be RFC 3986/, () => "اكتب رابطاً صحيحاً."],
  [/^expected string to match pattern/, () => "الصيغة غير صحيحة."],
  [/^expected boolean/, () => "نعم أو لا."],
  [/^expected array items to be unique/, () => "فيه عناصر مكررة."],
  [/^unexpected property/, () => "حقل غير معروف."],
  [/ isn't a stock item$/, () => "هذا الصنف ليس صنفاً مخزنياً؛ فعّل تتبع المخزون له."],
  [/^unknown batch /, () => "التشغيلة غير موجودة."],
  [/^unknown barcode /, () => "الباركود غير مسجل لأي صنف."],
  [/^unknown (permission|app|event|input) /, () => "قيمة غير معروفة."],
  [/^duplicate permission /, () => "الصلاحية مكررة."],
  [/^invalid value for \S+ field$/, () => "القيمة غير صحيحة."],
  [/^can't be less than claimed before \((.+)\)$/, (m) => `لا تقل عما صُرف في مستخلصات سابقة (${m[1]}).`],
  [/^must be at least (.+)$/, (m) => `لا تقل عن ${m[1]}.`],
  [/^must be at most (.+)$/, (m) => `لا تزيد عن ${m[1]}.`],
];

/** The Arabic for an API field message, if known. */
export function fieldMessageAr(message: string): string | undefined {
  const m = message.trim();
  if (fieldMessagesAr[m]) return fieldMessagesAr[m];
  for (const [re, fn] of patternsAr) {
    const hit = m.match(re);
    if (hit) return fn(hit);
  }
  return undefined;
}
